<app-carousel [dataList]="recommendedGames" [identifier]="identifierName"></app-carousel>

